import Enum from '../Question/Enum';

import { getOptionsFromRecord } from '../utils';

import * as api from '../../api';

interface Props {
  value: api.PatientSocialHistory.GenderIdentityFieldValue;
  updateFieldValue: (value: string) => void;
  saveFieldValue: (value: string) => void;
}

const genderIdentityValues = getOptionsFromRecord(
  api.Previsit.sexualIdentityMap,
);

export const GenderIdentity: React.FC<Props> = ({
  value,
  updateFieldValue,
  saveFieldValue,
}) => {
  const saveFormField = (update: {
    [key in keyof api.PatientSocialHistory.GenderIdentityFieldValue]?: string;
  }) => {
    const updatedValues = JSON.stringify({
      ...value,
      ...(update.identity &&
        update.identity !== api.PatientSocialHistory.SexualIdentity.Other && {
          identityRaw: undefined,
        }),
      ...update,
    });
    updateFieldValue(updatedValues);
    saveFieldValue(updatedValues);
  };

  return (
    <>
      <Enum
        value={value.identity || ''}
        options={genderIdentityValues}
        onChange={(identity: string) => {
          saveFormField({ identity });
        }}
        onCustomValueChange={(identityRaw: string) =>
          saveFormField({ identityRaw })
        }
        customValue={value.identityRaw || ''}
      />
    </>
  );
};
